import {
  Component, OnInit, Input, Output, EventEmitter, ViewContainerRef, OnDestroy,
  OnChanges, SimpleChanges, SimpleChange
} from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO,
  RequirementDO,
  /* Document Manager */
  AppConfig,
  EntityDocumentDO,
  AppMetadataHandler,
  UserInfoService,
} from 'app';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';

/* Document Manager */
import { HttpRequest, HttpClient, HttpEventType, HttpEvent, HttpResponse, HttpHeaders } from '@angular/common/http';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { forkJoin, Observable, Observer } from 'rxjs';
import { debounceTime, filter } from 'rxjs/operators';
//import {RequestMethod, ResponseContentType} from '@angular/http';
import { DomSanitizer } from '@angular/platform-browser';
import { DocumentManagerDataService } from './document-manager-data.service';
import { ErrorDO } from '../../../BaseFramework/shared/models/error.model';
import { CriteriaIO, SearchCriteriaDO } from '../../../BaseFramework/shared/models';

import { DataTransformService } from 'app/ViewModules/shared-services'; 
import * as moment from 'moment/moment';
import { PolicyService } from 'app/FunctionalModules';
declare var Tiff: any;
@Component({
  selector: 'app-ocr-details',
  templateUrl: './ocr-details.component.html',
  styleUrls: ['./ocr-details.component.scss']
})
export class OcrDetailsComponent implements OnInit {

  constructor(
    private viewContainerRef: ViewContainerRef,
    private validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    private interactService: InteractService,
    private userInfoService: UserInfoService,
    /* Document Manager */
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private msg: NzMessageService,
    private appConfig: AppConfig,
    public appMetadataHandler: AppMetadataHandler,
    private docManDataService: DocumentManagerDataService,
    private policyService: PolicyService,
    public dataTransformService : DataTransformService
  ) { }


  @Input() clientRefGuid: any = null;
  @Input() clientDO: any = null;

  @Input() RequirementEntityGuid: any;
  mapperTableIndex: number = 1;
  mapperTablePageSize: number = 10;

  private _IO = null;
  @Input() transactionState: string;
  @Input() showLabReportSummary = false;
  @Input()
  set IO(value: any) {
    this._IO = value;
  };

  get IO() {
    return this._IO;
  }

  _labReportRequirements = [];
  @Input()
  set labReportRequirements(value: any) {
    this._labReportRequirements = value;
  };
  get labReportRequirements() {
    return this._labReportRequirements
  }
  

  
  @Output() updateSelectedReportData = new EventEmitter<any>();
  @Output() updateValidatedData = new EventEmitter<any>();
  @Output() emitMedicalReportSummary = new EventEmitter<any>();

  documentsFromServer: any; //complete list of documents from server (guid fetch)
  documentsFromServerMini: any; //complete list of documents from server (guid fetch) BACKUP as first loop filters above var
  documents: any;
  isReady: boolean = false;
  isProd: boolean = environment.production;
  looseDocsKey: string = 'LOOSE_DOCUMENTS';
  enableAddUpdateLabReport : boolean = true;
  /* Internally used */
  /* this is filtered and emitted */
  documentCollectionLoose: any = [];


  /* App config vars & defaults */
  defaultVisibilityCd: string = "INTERNAL"; // This will be used as default for NEW upload and NEW requirement
  defaultVisibilityCdExternalUser: string = "EXTERNAL"; // This will be used as default for NEW upload and NEW requirement for an EXTERNAL USER
  defaultStatusCd: string = "IDENTIFIED";   // This will be used as default for NEW requirement
  userIsExternal: boolean = false;
  notSupportedText: string = "Please download document to view contents"; // Default text for non-supported file types. Use i18n


  requirementList = [];
  fileList = [];
  documentCollection: any = [];
  OCR_Result = [];

  fileUploadEndpoint: string;

  /* Tab Index */
  tabIndex: number = 0;
  documentPreview

  ngOnInit() {
    this.requirementList = this._labReportRequirements;
    this.initUploadVars();
    //this.fetchAllOCRData();
    /* No requirements ? Get RequirementDO (POLICY INITIALIZATION CASE) */
    if ((Array.isArray(this._labReportRequirements) && this._labReportRequirements.length == 0) && this.RequirementEntityGuid) {
      let url = 'requirementFetchByEntityGuid'
      let pathVariables = []
      pathVariables.push(this.RequirementEntityGuid)
      this.apiRequestService.getCallWithAPIMapper(url, null, null, pathVariables).subscribe(data => {
        if (data) {
          this.initDocumentData([], data);
        }
      });
    }
    
    /* Initialize MAIN onInit() */
    this.initDocumentData(this.documents, this._labReportRequirements);

  }

  draggableBoxes = []
  openDraggableImgPreviewModal(fileName) {
    this.draggableBoxes = [];
    // let previewName = this.guessOriginalFileNameFromImgURL(this.previewFileUrl) + ' preview'
    let obj = {
      title: fileName, width: "850px", height: "700px", minWidth: "400px", type: "documentPreview", open: true, minimized: false, zIndex: 999, data: { id: 10, desc: "Pass a data object" }, toReset: 'documentPreview'
    }
    this.draggableBoxes.push(obj);
  }

   /* Draggable Boxes - Functions */
   bringDraggableBoxToTop(i:number, highest=0) {
    this.draggableBoxes.forEach(i=>{if(highest<i.zIndex) highest=i.zIndex;});
    if(this.draggableBoxes[i].zIndex<highest) this.draggableBoxes[i].zIndex = highest + 1;
  }
  deleteBox(i) {
    this.draggableBoxes[i].open = false; 
    // this.draggableBoxes[i].minimized = true; 
    this.draggableBoxes.splice(i,1);
    // close it first
     // delete
    // this.makeBoxesDraggable(); // re-init() drags (Required for jQuery version alone)
  }
  /* ================ END Draggable Boxes ================ */

  initUploadVars() {
    /* API Endpoints */
    this.fileUploadEndpoint = this.appConfig.baseApiPath + 'document/saveMultipart';
    this.fileFetchEndpoint = this.appConfig.baseApiPath + 'document/fetchMultipart';
    /* Set loose_docs key
    switch (this.entity) {
      case 'policy': this.looseDocsKey = "POLICY_DOCUMENTS"; break;
      case 'claim': this.looseDocsKey = "CLAIM_DOCUMENTS"; break;
      default: this.looseDocsKey = "LOOSE_DOCUMENTS"; break;
    } */
  }

  current_requirementObj_for_uploading_report = {};
  uploadReportModal: boolean = false;
  showDocumentUploadPopup(selectedRequirement) {
    this.uploadReportModal = true;
    this.current_requirementObj_for_uploading_report = selectedRequirement;
  }

  showUploadList = {
    showPreviewIcon: false,
    showRemoveIcon: false,
    hidePreviewIconInNonImage: false
  };

  /*previewImage: string | undefined = '';
  previewVisible = false;
  handlePreview = (file: NzUploadFile) => {
    this.previewImage = file.url || file.thumbUrl;
    this.previewVisible = true;
  };*/

  sel_documentTypeCd: any = '';
  sel_documentSubTypeCd: any = '';
  sel_visibilityCd: any = '';
  sel_clientRefGuid: any = '';
  /* setUploadParams() is required because there no way to set/pass dynamic values to nzBeforeUpload */
  setUploadParams(req, tabIndex: number = 0, clientRef: any = false) {
    this.RequirementEntityGuid = req.entityGuid;
    this.sel_documentTypeCd = req.requirmentTypeCd;
    this.sel_documentSubTypeCd = req.appliesToCd;
    this.sel_clientRefGuid = clientRef ? clientRef : req.clientRefGuid;
    this.sel_visibilityCd = req.visibilityCd || this.defaultVisibilityCd; /**^^^*/ // Set default visibility
    if (this.userIsExternal) this.sel_visibilityCd = this.defaultVisibilityCdExternalUser; /**^^^*/ // Force change visibility for external users to PUBLIC
    this.tabIndex = tabIndex; /**^^^*/
  }

  /* File Operations */
  fileListTemp: NzUploadFile[] = [];
  uploading: boolean = false;
  fileFetchEndpoint: string;

  fileUploadBefore = (file: NzUploadFile, fileList): boolean => {
    this.preUploadImgChecks(file).subscribe(
      n => {
        if (n) { //n = true => All passed
          this.fileListTemp = []; //reset
          this.fileListTemp.push(file); //push
          this.fileUpload(); // handle upload & reset component
          return true;
        }
      },
      e => { return false },
      () => { return false }
    );
    return false; // We need to return false to nz-upload (else it will invoke onError())
  };

  /* Image Upload checks */
  preUploadImgChecks = (file: NzUploadFile) => {
    return new Observable((observer: Observer<boolean>) => {
      /* Max File Size */
      const maxFileSize = 5; /* in MB */

      /* Supported file types */
      let fileName = file.name;
      let fileType = file.type;

      let isSupportedFileType = file.type.includes('image') || file.type.includes('pdf');

      /* New check for 'supported file' upload [overrides previous check] */
      if (this.guessFileType(fileName) !== "File") isSupportedFileType = true;

      console.log("File Name, File type: ", fileName, " ----- ", fileType);

      if (!isSupportedFileType) {
        this.msg.error(`Unsupported file type. Please select a Document or Image file`);
        observer.complete();
        this.initDocumentData(this.documents, this._labReportRequirements); //reset
        return;
      }
      const fileSizeOK = file.size / 1024 / 1024 < maxFileSize;
      if (!fileSizeOK) {
        this.msg.error(`Document must smaller than ${maxFileSize} MB`);
        observer.complete();
        this.initDocumentData(this.documents, this._labReportRequirements); //reset
        return;
      }
      observer.next(isSupportedFileType && fileSizeOK);
      observer.complete();
      return;
    });
  };

  /* Generic function to guess file type */
  /* NOW ALSO USED as for finding 'supported files' *** */
  guessFileType(url): string {
    let extension = url;
    if (url && url.length > 4) extension = this.guessFileExtension(url);
    /* Find file type */
    if (['jpg', 'png', 'x-png', 'jpeg', 'pjpeg', 'jfif', 'gif', 'tiff', 'tif', 'bmp', 'webp'].includes(extension)) return "Image";
    else if (['pdf', 'doc', 'docx'].includes(extension)) return "Document";
    else if (['mp4', 'mov', 'avi', 'mpeg', 'webm'].includes(extension)) return "Video";
    else if (['mp3', 'wav', 'ogg'].includes(extension)) return "Audio";
    else if (['xls', 'xlsx', 'xlt', 'xltx', 'xlsm', 'xlsb', 'xla', 'xlam', 'xltm'].includes(extension)) return "Sheet";
    else if (['zip', 'gz', 'rar', 'rar5'].includes(extension)) return "Archive";
    else if (['eml', 'msg'].includes(extension)) return "Email";
    else if (['html', 'htm'].includes(extension)) return "HTML";
    return "File"; // un-supported
  }

  /* Core function that handles upload */

  headers: HttpHeaders = new HttpHeaders({
    'Authorization': this.apiRequestService.token,
    'applicationId': environment.applicationId,
    'hash': '7h1nk[)j',
  });

  /* Handles the uploading of file */
  fileUpload(): void {
    const url = this.fileUploadEndpoint;
    const formData = new FormData();
    //this.uploading = true;
    //this.isReady = false; // loading ...
    this.msg.loading('Uploading document', { nzDuration: 1000 });
    // Set Data & Defaults for the Uploaded file
    let lastFilename = '', lastFiletype = '';
    this.fileListTemp.forEach((file: any) => { lastFilename = file.name; lastFiletype = file.type; });

    const obj = {
      entityGuid: this.RequirementEntityGuid,
      documentTypeCd: this.sel_documentTypeCd,
      documentSubTypeCd: this.sel_documentSubTypeCd,
      guid: this.randomString(10),
      entityImageName: lastFilename,
      entityImageMimeType: lastFiletype,
      clientRefGuid: this.clientRefGuid ? this.clientRefGuid : this.sel_clientRefGuid ? this.sel_clientRefGuid : this.clientDO.guid ? this.clientDO.guid : null,
      visibilityCd: this.userIsExternal ? this.defaultVisibilityCdExternalUser : this.defaultVisibilityCd, // this.sel_visibilityCd, // Set default PRIVATE status to newly uploaded file
    };
    console.log("Doc Save POST Object");
    console.table(obj);
    const options = {
      reportProgress: true,
      headers: this.headers,
    };
    formData.append('json', JSON.stringify(obj));
    // Attach File(s) [1 in this case]
    this.fileListTemp.forEach((file: any) => {
      formData.append('file', file);
      this.getMedicalSummary(file);
    });
    const req = new HttpRequest('POST', url, formData, options);
    this.http
      .request(req)
      .pipe(filter(e => e instanceof HttpResponse))
      .subscribe(
        (e: {}) => {
          //this.uploading = false;
          this.msg.success('Upload successful');
          this.forceUpdateDocData(e); // this calls dataHasChaged
          this.fileListTemp = [];
        }, (e) => {
          //this.uploading = false;
          this.initDocumentData(this.documents, this._labReportRequirements); // Re-initialize doc data
          this.msg.error('Upload failed');
        }
      );
  }

  /* FORCE update document data upon uploading a new file */
  forceUpdateDocData(docData: any) {
    //this.isReady = false;
    // Save Requirements
    this.saveRequirements(docData);
    // Save Documents
    let documentDOs = this.extractDocumentDOs();
    // Append newly uploaded file data !!!
    if (docData) {
      let docNew = docData.body; // MUST pass `body` only as it's HTTP request
      documentDOs.push(docNew);
    }
    let url = 'documentSave'
    this.apiRequestService.postCallWithAPIMapper(url, documentDOs).subscribe(d => {
      console.log("Document Save response", d);
      // Reload component & emit for other sub-views (Mini views)
      this.docManDataService.dataHasChanged(this.RequirementEntityGuid);
    });
    return;
  }

  /* Save Requirements */
  saveRequirements(docData) {
    let req = this.extractRequirementDOs();
    if (!req) return;
    let url = 'requirementSave'
    this.apiRequestService.postCallWithAPIMapper(url, req).subscribe(respRequirements => {
      console.log("Reqirement Save response", respRequirements);
      if (respRequirements) {
        console.log("Reqirement Save sucessful. Re-init() with new Reqs");
        this._labReportRequirements = respRequirements;
        let data = null;
        this.saveUpdateOCRData(docData['body']['guid']);
        this.initDocumentData(data, this._labReportRequirements);        
      }
    });
  }

  extractDocumentDOs() {
    /* Fetches the freshest docs list to emit */
    let docDOAll = [];
    //let docDOLoose = [];
    if (this.documentCollection && this.documentCollection.length > 0)
      this.documentCollection.forEach(document => {
        if (document['documents'].length) docDOAll.push(...document['documents']);
      });
    // if (this.documentCollectionLoose && this.documentCollectionLoose.length > 0)
    //   this.documentCollectionLoose.forEach(document => {
    //     if (document['documents'].length) docDOLoose.push(...document['documents']);
    //   });
    /* no need to merge, as it is by reference */
    let documentDO = docDOAll;
    return documentDO;
  }

  extractRequirementDOs() {
    let requirementDOs = [];
    if (this.documentCollection && this.documentCollection.length > 0)
      this.documentCollection.forEach(document => {
        if (document['requirements'].requirementCd !== this.looseDocsKey) requirementDOs.push(document['requirements']);
      });
    return requirementDOs;
  }

  private initDocumentData(data, requirements) {
    //this.isReady = false;

    /* "NEW" cases */
    if (!this.RequirementEntityGuid) { // || !requirements
      //this.isReady = true;
      return;
    }

    //if (this.clientRefGuid) this.mode = "mini"; /* if clientRefGuid is passed via @Input(), show mini mode */

    /* Set Document Collection */
    this.documentCollection = [];

    /* Copy Requirements */
    if (requirements) {
      requirements.forEach((req, index) => {
        //delete req.requirementChaserDOs;
        this.documentCollection[index] = {};
        this.documentCollection[index]['requirements'] = req;
        this.documentCollection[index]['documents'] = [];
        this.documentCollection[index]['UiFilesList'] = [];
      });
    }

    /* Additionally, append Loose Documents to the end */
    this.addUploadRowLooseDocs();

    /* Data exists? SET it -- Reserved for Future use */
    if (data) {
    }

    /* Get all documents of this Entity using its `guid` */
    let url = 'documentFetchByEntityGuid'
    let pathVariables = [];
    pathVariables.push(this.RequirementEntityGuid);
    this.apiRequestService.getCallWithAPIMapper(url, null, null, pathVariables).subscribe(data => {
      //this.documentsFromServerMini = JSON.parse(JSON.stringify(data));
      this.documentsFromServer = data;
      this.documents = data;
      /* All documents from server */
      if (this.documentsFromServer.length) {

        this.documentCollection.forEach((d, index) => {
          // Set default visibility for Requirement Visibility
          if (!d.requirements.visibilityCd) d.requirements.visibilityCd = this.defaultVisibilityCd;

          let category = d.requirements.requirementCd;
          let clientGuid = d.requirements.clientRefGuid;
          d.documents = this.documentsFromServer.filter(i => i.documentTypeCd == category && i.clientRefGuid == clientGuid); //CHANGE LOGIC HERE
          // Remove used docs from main list (filter !=) to keep only loose_docs in the end
          this.documentsFromServer = this.documentsFromServer.filter(i => !(i.documentTypeCd == category && i.clientRefGuid == clientGuid)); //CHANGE LOGIC HERE

          /* Set date */
          // if (d.requirements.receivedDt) {
          //   this.dateArray[index] = new Date(d.requirements.receivedDt);
          // }
          // else this.dateArray[index] = null;

        });

        /* Sort by Document's ID (server returns reverse order!; so that wont work for us as we use doc[0] for saving meta data) */
        this.documentCollection.forEach((d, index) => {
          if (d.documents.length) {
            d.documents.sort(this.dynamicSort('id'));
          }
        });


        /* Put all unassigned docs in LOOSE_DOCS */
        let indexLooseDocs = this.documentCollection.length - 1;
        this.documentCollection[indexLooseDocs].documents.push(...this.documentsFromServer);
        this.fileList = this.documentCollection[indexLooseDocs].documents;
        /* Transform all LOOSE_DOCS for custom multi-level view */
        this.documentCollectionLoose = [];
        /* we are creating fake 'requirements' for loose doc categories (UI purposes alone) */
        let looseDocReqs = this.documentCollection[indexLooseDocs].requirements;
        let allLooseDocs = this.documentCollection[indexLooseDocs].documents || [];

        allLooseDocs.forEach((doc, index) => {

          let category = doc.documentTypeCd;
          let subCategory = doc.documentSubTypeCd;

          /* If already processed, continue */
          if (this.documentCollectionLoose.filter(dc => { return dc.requirements.requirementCd == category && dc.requirements.appliesToCd == subCategory }).length) {
            //CHANGE LOGIC HERE (loose document hierarchy filter)
          }
          else {
            /* Create a new fake requirement w/ its document set */
            /* NEW Requirement (User for UI alone) */
            let documentCollectionObj = {
              'requirements': new RequirementDO(),
              'documents': [],
              'UiFilesList': [],
            };
            documentCollectionObj['requirements'].entityGuid = this.RequirementEntityGuid;
            documentCollectionObj['requirements'].requirementCd = category;
            documentCollectionObj['requirements'].appliesToCd = subCategory;
            documentCollectionObj['requirements'].mandatoryFl = "NO";
            documentCollectionObj['requirements'].clientId = null;
            /* Add the documents */
            let docs = allLooseDocs.filter(i => { return i.documentTypeCd == category && i.documentSubTypeCd == subCategory }); //CHANGE LOGIC HERE (loose document hierarchy filter)
            // Remove used docs from main list (filter !=)
            //allLooseDocs = allLooseDocs.filter(i=>{return i.documentTypeCd!==category && i.documentSubTypeCd!==subCategory}); //CHANGE LOGIC HERE (loose document hierarchy filter)
            documentCollectionObj['documents'] = docs;
            this.documentCollectionLoose.push(documentCollectionObj);
          }

          /* Sort by Document's ID (server returns reverse order!; so that wont work for us as we use doc[0] for saving meta data) */
          this.documentCollectionLoose.forEach((d, index) => {
            if (d.documents.length) {
              /* Sort */
              d.documents.sort(this.dynamicSort('id'));
            }
          });

        });


        /* Transform and Set * /
        for( let i=0; i<this.documentsFromServer.length; i++ ) {
          //this.documentCollection[0]['UiFilesList'].push(this.transformToNZobj(this.documentsFromServer[i]));
          this.documentCollection[0]['documents'].push(this.documentsFromServer[i]);
        }
        /* */

        this.fetchAllOCRData();
        this.fetchImagePreview(this.currentOCRDocumentGuid);
        //this.validateData();
      }

      /* Set meta and process dates for missing ones */
      // this.documentCollection.forEach((d, index) => {
      //   // Set default visibility for Requirement Visibility
      //   if (!d.requirements.visibilityCd) d.requirements.visibilityCd = this.defaultVisibilityCd;
      //   /* Set date */
      //   if (d.requirements.receivedDt) {
      //     this.dateArray[index] = new Date(d.requirements.receivedDt);
      //   }
      //   else this.dateArray[index] = null;
      // });



      /* Init Mini View */
      //this.initMiniView();

      /* Enable UI display */
      // setTimeout(() => {
      //   this.isReady = true;
      //   /* Init Mini View */
      //   this.initMiniView();
      // }, 512);

    });

  }

  addUploadRowLooseDocs() {
    let documentCollectionObj = {
      'requirements': new RequirementDO(),
      'documents': [],
      'UiFilesList': [],
    };
    documentCollectionObj['requirements'].entityGuid = this.RequirementEntityGuid;
    if (!environment.production && !this.appMetadataHandler.featureFlags.allowEmptyReqEntityGuid) {
      if (!documentCollectionObj['requirements'].entityGuid) {
        console.log('Current Transaction Payload');

        //throw "EnitityGuid for Requirement added is NULL, Please send valid Input of RequirementEntityGuid to DocumentManagerComponent in" + this.getParentComponentName();
      }
      if (!this.documentCollection) {
        console.log('Current Transaction Payload');
        //throw `documentCollection Not initialized properly in ${this.getCurrentComponentName()} which is placed in ${this.getParentComponentName()}`
      }
    }

    /* NEW ROW: Loose Docs */
    documentCollectionObj['requirements'].requirementCd = this.looseDocsKey;  //"LOOSE_DOCUMENTS" made an @Input() var
    documentCollectionObj['requirements'].appliesToCd = "SYSTEM";
    documentCollectionObj['requirements'].mandatoryFl = "NO";

    if (!this.documentCollection)
      this.documentCollection = [];
    this.documentCollection.push(documentCollectionObj)
  }

  fetchedAllDocumentOCRDataList = [];
  selectedOCRDataList=[];
  labReportDocuments = [];
  loader : boolean = false;
  fetchAllOCRData() {
    this.loader = true;
    let url = 'labtestFetchByEntityGuid'
    let pathVariables = []
    pathVariables.push(this.RequirementEntityGuid)
    this.apiRequestService.getCallWithAPIMapper(url, null, null, pathVariables).subscribe(data => {
      if (data && this.commonUtilty.isArrayIterable(data) && data.length) {
        this.fetchedAllDocumentOCRDataList = [...data];
        this.selectedOCRDataList = this.filteredSelectedOCRData();
        this.updateSelectedReportData.emit(this.selectedOCRDataList);
        this.getDocumentName();
        if(this.fetchedAllDocumentOCRDataList && this.commonUtilty.isArrayIterable(this.fetchedAllDocumentOCRDataList) && this.fetchedAllDocumentOCRDataList.length && this.fetchedAllDocumentOCRDataList[0].documentGuid){
          this.currentOCRDocumentGuid = this.fetchedAllDocumentOCRDataList[0].documentGuid
        }

        this.documentCollection.forEach(dc =>{
          dc.documents.forEach(file =>{
            if(file.documentTypeCd == 'LABTEST')
            this.labReportDocuments = this.commonUtilty.uniquePushInArray(this.labReportDocuments , file , 'guid')
          })
        })
        //this.fetchedDocumentListOfOCRData = this.ListOfAllOCRDocuments();
        this.loader = false
      }
      else {
        this.fetchDocumentAndSaveLabTest();
        // this.loader = false
      }
    });
  }

  fetchDocumentAndSaveLabTest(){
    let url = 'documentFetchByEntityGuid'
    let pathVariables = [];
    pathVariables.push(this.RequirementEntityGuid);
    this.apiRequestService.getCallWithAPIMapper(url, null, null, pathVariables).subscribe(documents => {
      if(documents && this.commonUtilty.isArrayIterable(documents) && documents.length){
        let labTestDocument = documents.filter(doc => doc.documentTypeCd == "LABTEST")
        let labTestGuid = null
        if(labTestDocument && this.commonUtilty.isArrayIterable(labTestDocument) && labTestDocument.length) 
          labTestGuid = labTestDocument[0].guid;
        
        if(labTestGuid){
          let body = {
            "documentGuid": labTestGuid,
            "labTestDOs": []
          }
          console.log("check payload body before save lab test: ", body)
          this.msg.loading('Saving', { nzDuration: 500 });
          let url = 'labtestSave'
          this.apiRequestService.postCallWithAPIMapper(url,body).subscribe(data => {
            if (data) {
              // this.fetchedAllDocumentOCRDataList = [...data];        
              // this.selectedOCRDataList = this.filteredSelectedOCRData();
              // this.updateSelectedReportData.emit(this.selectedOCRDataList);
              // this.msg.info('Data Updated successfully!!');
              // this.uploadReportModal = false;
              //this.fetchedDocumentListOfOCRData = this.ListOfAllOCRDocuments();
              this.loader = true;
              let url = 'labtestFetchByEntityGuid'
              let pathVariables = []
              pathVariables.push(this.RequirementEntityGuid)
              this.apiRequestService.getCallWithAPIMapper(url, null, null, pathVariables).subscribe(data => {
                if (data && this.commonUtilty.isArrayIterable(data) && data.length) {
                  this.fetchedAllDocumentOCRDataList = [...data];
                  this.selectedOCRDataList = this.filteredSelectedOCRData();
                  this.updateSelectedReportData.emit(this.selectedOCRDataList);
                  this.getDocumentName();
                  if(this.fetchedAllDocumentOCRDataList && this.commonUtilty.isArrayIterable(this.fetchedAllDocumentOCRDataList) && this.fetchedAllDocumentOCRDataList.length && this.fetchedAllDocumentOCRDataList[0].documentGuid){
                    this.currentOCRDocumentGuid = this.fetchedAllDocumentOCRDataList[0].documentGuid
                  }
          
                  this.documentCollection.forEach(dc =>{
                    dc.documents.forEach(file =>{
                      if(file.documentTypeCd == 'LABTEST')
                      this.labReportDocuments = this.commonUtilty.uniquePushInArray(this.labReportDocuments , file , 'guid')
                    })
                  })
                  //this.fetchedDocumentListOfOCRData = this.ListOfAllOCRDocuments();
                  this.loader = false
                }
                else {
                  // this.fetchDocumentAndSaveLabTest();
                  this.msg.info("Please upload lab test report", )
                  this.loader = false
                }
              });
            }
          });
        }
        else this.loader = false
      }
      else{
        this.msg.info("Please upload lab test report", )
        this.loader = false
      }
    })
  }

  getDocumentName(){
    if(this.commonUtilty.isArrayIterable(this.fetchedAllDocumentOCRDataList) && this.commonUtilty.isArrayIterable(this.documents)){
      for(let i=0; i< this.fetchedAllDocumentOCRDataList.length; i++){
        for(let j=0; j<this.documents.length; j++){
          if(this.fetchedAllDocumentOCRDataList[i].documentGuid == this.documents[j].guid){
            this.fetchedAllDocumentOCRDataList[i]['entityImageName'] = this.documents[j]['entityImageName'];
            break;
          }
        }
      }
    }
  }

  // ListOfAllOCRDocuments(){
  //   let docList = [];
  //   if(this.commonUtilty.isArrayIterable(this.fetchedAllDocumentOCRDataList)){
  //     this.fetchedAllDocumentOCRDataList.forEach(document => {
  //       docList.push(document.documentGuid);
  //     });
  //   }
  //   return docList;
  // }

  updateAllOCRData(validatedResp){
    if(!this.commonUtilty.isArrayIterable(this.fetchedAllDocumentOCRDataList)){
      this.msg.info('Please upload the document to update the data.');
      return;
    }
    if(this.commonUtilty.isArrayIterable(validatedResp) && this.currentOCRDocumentGuid && this.medicalSummary)
    {
      validatedResp.forEach(item =>{
        if(item.documentGuid == this.currentOCRDocumentGuid)
        {
          item.summary = this.medicalSummary
        }
      })
    }
    let body = {
      "documentGuid": this.fetchedAllDocumentOCRDataList.find(e=> true).documentGuid,
      "labTestDOs": validatedResp
    }
    console.log("check payload body before save lab test: ", body)
    this.msg.loading('Saving', { nzDuration: 500 });
    let url = 'labtestSave'
    this.apiRequestService.postCallWithAPIMapper(url,body).subscribe(data => {
      if (data) {
        this.fetchedAllDocumentOCRDataList = [...data];        
        this.selectedOCRDataList = this.filteredSelectedOCRData();
        this.updateSelectedReportData.emit(this.selectedOCRDataList);
        this.msg.info('Data Updated successfully!!');
        this.uploadReportModal = false;
        //this.fetchedDocumentListOfOCRData = this.ListOfAllOCRDocuments();
      }
    });
  }

  filteredSelectedOCRData(){
    let tempArray = [];
  
    if (this.commonUtilty.isArrayIterable(this.fetchedAllDocumentOCRDataList)) {
      this.fetchedAllDocumentOCRDataList.forEach(OCRData => {
        if (this.commonUtilty.isArrayIterable(OCRData.labTestResults)) {
          let selectedData = OCRData.labTestResults.filter(data => data.summaryFl === true && data.typeCd != 'HEALTHATTRIBUTES');
  
          if (selectedData) {

            selectedData.forEach(data => {
              if (data.value < data.referenceMinValue ||data.value > data.referenceMaxValue) {

                data.highlighted = true;
              }
            });

            tempArray = [...tempArray, ...selectedData];
          }
        }
      });
    }
    return tempArray;
  }

  currentOCRDocumentGuid;
  labTestResponse = [];
  saveUpdateOCRData(documentGuid?) {
    if (documentGuid) {
      this.currentOCRDocumentGuid = documentGuid;
      this.OCR_Result = [];
      this.labTestResponse = [];
    }
    if (this.OCR_Result.length > 0 && this.commonUtilty.isArrayIterable(this.labTestResponse)) {
      this.labTestResponse.find(e => true)['labTestResults'] = [...this.OCR_Result];
      this.OCR_Result = [];
    }

    let body = {
      "documentGuid": this.currentOCRDocumentGuid,
      "labTestDOs": this.labTestResponse
      //"labTestDOs": this.OCR_Result && this.OCR_Result.length > 0 ? this.OCR_Result : this.temp_OCRResult
    }
    let url = 'labtestSave'
    this.apiRequestService.postCallWithAPIMapper(url,body).subscribe(resp => {
      if (Object.keys(resp).length != 0 && this.commonUtilty.isArrayIterable(resp)) {
        this.labTestResponse = [...resp];
        this.OCR_Result = resp && resp[0] ? this.commonUtilty.deepCopy(resp[0]['labTestResults']) : []
      } else {
        this.msg.info("No records fetched to display.")
      }
    });
  }

  fetchedSelectedDocData = {};
  fetchDocumentData(selectedDocGuid) {
    this.currentOCRDocumentGuid = selectedDocGuid;
    this.fetchImagePreview(this.currentOCRDocumentGuid);
    // this.apiRequestService.get(`labtest/fetchByEntityGuid/${this.RequirementEntityGuid}/${this.currentOCRDocumentGuid}`).subscribe(resp => {
    //   if (Object.keys(resp).length != 0 && this.commonUtilty.isArrayIterable(resp)) {
    //     this.labTestResponse = [...resp];
    //     this.OCR_Result = resp && resp[0] ? this.commonUtilty.deepCopy(resp[0]['labTestResults']) : []
    //     this.fetchImagePreview(this.currentOCRDocumentGuid);
    //   }
    // });
  }


  selectedDoc;
  previewImgSrc;
  showPDF : boolean = false
  fetchImagePreview(selectedDocGuid) {
    if (this.commonUtilty.isArrayIterable(this.documents)) {
      for (let i = 0; i < this.documents.length; i++) {
        if (this.documents[i]['guid'] == selectedDocGuid) {
          this.selectedDoc = this.documents[i];
          break;
        }
      }
      if (this.selectedDoc && this.selectedDoc.entityImageMimeType && this.selectedDoc.entityImage)
        this.previewImgSrc = this.sanitizer.bypassSecurityTrustResourceUrl(`data:\ ${this.selectedDoc.entityImageMimeType};base64, ${this.selectedDoc.entityImage}`);

      if(this.selectedDoc && this.selectedDoc.entityImageMimeType && this.dataTransformService.documentPreview) {
        this.openDraggableImgPreviewModal(this.dataTransformService.documentPreview['fileName']);
        this.showPDF = true 
      }
    }
  }

  /* =========== File name Helpers (guessers) =========== */
  /* @thinkdj 30 July 2019 */
  guessFileName(url) {
    if (!url) { return ''; }
    const character = (url.indexOf('\\') > -1) ? '\\' : '/';
    return url.substring(url.lastIndexOf(character) + 1);
  }
  guessFileExtension(url) {
    const filename = this.guessFileName(url);
    return String(filename.substring(filename.lastIndexOf('.') + 1)).toLowerCase();
  }
  guessOriginalFileName(fileObj) {
    if (typeof fileObj !== 'object') { return ''; }
    return (fileObj.entityImageName) ? fileObj.entityImageName : this.guessFileName(fileObj.imageURL);
  }
  guessOriginalFileNameFromImgURL(imgUrl) {
    if (!this.documentsFromServerMini || !this.documentsFromServerMini.length) return '';
    const fileObj = this.documentsFromServerMini.find(d => d.imageURL === imgUrl); /* unfiltered copy of documentsFromServer */
    if (typeof fileObj === 'object') { return this.guessOriginalFileName(fileObj); }
    return '';
  }

  /* Guess filetype IF extension is not found in file URL (Eg: filenet case) */
  guessFileExtensionFromMIME(url) {
    // (1) Take from entityImageMimeType (2) Split `/` (3) Return extension
  }


  fileIsPreviewable(url): boolean {
    let supportedFormats = [ // Add all supported formats here
      'jpg', 'png', 'jpeg', 'jfif', 'gif', 'bmp', 'webp', //Images
      'tif', 'tiff', // TIFF images (requires decoder plugin)
      'mp4', 'mov', 'avi', 'mpeg', 'webm', // Videos
      'mp3', 'wav', 'ogg', //Audio
      'pdf', // PDF Doc
      'html', 'htm', // HTML Files
    ];
    let extension = this.guessFileExtension(url);
    return supportedFormats.includes(extension);
  }

  randomString(len, charSet?) {
    charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var randomString = '';
    for (var i = 0; i < len; i++) {
      var randomPoz = Math.floor(Math.random() * charSet.length);
      randomString += charSet.substring(randomPoz, randomPoz + 1);
    }
    return randomString;
  }

  dynamicSort = function (property) {
    return function (a, b) {
      return (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
    }
  };

  handlePreview = (file: NzUploadFile) => {
  };
  getDO(IO) {
    if (IO)
      return IO['intimationDO'] || IO['claimDO'] || IO['adjudicationDO'] || IO['investigationDO'] || IO['policyDO'] || IO['caseDO'];
    else
      null
  }

  validateData(){
    let caseDO = this.getDO(this._IO)
    var criteriaObj = new CriteriaIO();
    let searchCriteriaList: SearchCriteriaDO[] = [];

    var searchCriteriaDO1 = new SearchCriteriaDO();
    searchCriteriaDO1.setParamName("policyGuid");
    searchCriteriaDO1.setParamValue(caseDO.guid);
    searchCriteriaList.push(searchCriteriaDO1);

    var searchCriteriaDO2 = new SearchCriteriaDO();
    searchCriteriaDO2.setParamName("clientGuid");
    searchCriteriaDO2.setParamValue(this.clientDO.guid);
    searchCriteriaList.push(searchCriteriaDO2);

    criteriaObj.setSearchCriteriaList(searchCriteriaList);
    this.msg.loading('Validating', { nzDuration: 500 });

    this.policyService.validateLabData(criteriaObj).subscribe( resp => {
      console.log("lab test response: ", resp)
      
      this.updateValidatedData.emit(resp);
      this.updateAllOCRData(resp);
      this.uploadReportModal = false;
    })
  }

  medicalSummary:string;
  generatingMedicalSummary: boolean = false;
  getMedicalSummary(file) {
    this.generatingMedicalSummary = true;
    let base64OCR = null;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      base64OCR = reader.result
      console.log("base 64 string for file: ", reader.result);

      let request_payload = {
        "product_type": "LIFE_Claims_Dev",
        "business_process": "FWARISKANALYSIS",
        "module_name": "VisionIntelligence",
        "apiKey": "c63ac4e0a3ae4803a562d20b8df0311d",
        "outputLang": "ENGLISH",
        "file": base64OCR
      }
      this.multiLingualService.generateMedicalSummary(request_payload).subscribe(resp => {
        console.log("summary resp: ", resp)
        this.medicalSummary = resp.medicalSummary;
        this.generatingMedicalSummary = false;
        this.emitMedicalReportSummary.emit(this.medicalSummary);
        
      }, (e) => {
        console.log("error captured  for generating medical summary: ", e)
        this.generatingMedicalSummary = false;
      })


    }
  }
}
